<template>
    <div>
        <b-form-file 
            type="file"
            name="files"
            id="fileInput"
            @change="onChange"
            ref="files"
            class="mt-3" plain
            accept="image/*"
        ></b-form-file>

        <div class="mt-3">Selected file: {{ files ? files.name : '' }}</div>
        <div v-if="imageUrl" class="mt-3">
            <img :src="imageUrl" alt="File preview" class="preview-image"/>
        </div>
    </div>
</template>

<script>
export default {
    props: ['value'],
    data() {
        return {
            files: this.value,
            imageUrl: null, 
        }
    },
    methods: {
        onChange(event) {
            this.files = event.target.files[0]; 
            this.$emit("change-value", event.target.files);
            if (this.files) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageUrl = e.target.result;
                };
                reader.readAsDataURL(this.files);
            }
        },
    },
}
</script>

<style>
.preview-image {
    width: 100%; 
    height: auto;
}
</style>
